import { createSelector } from "reselect";

import getUserAgent from "./getUserAgent";
import getIsiPad from "./getIsiPad";

export const getIsDesktop = createSelector(
  [getIsiPad, getUserAgent],
  (isIpad, userAgent) => !isIpad && userAgent.isDesktop,
);

export default getIsDesktop;
